/**
 * Destinations the marketing site links to from more than one place, so the navbar, the
 * home page sections and the footer cannot drift apart.
 */

const getEnvVar = (name: string): string | undefined => {
  if (typeof import.meta !== "undefined" && import.meta.env && import.meta.env[name]) {
    return import.meta.env[name];
  }
  if (typeof process !== "undefined" && process.env && process.env[name]) {
    return process.env[name];
  }
  return undefined;
};

export const CONTACT_MAIL =
  getEnvVar("VITE_B2B_CONTACT_EMAIL") ??
  getEnvVar("NEXT_PUBLIC_B2B_CONTACT_EMAIL") ??
  "team@inarax.ai";

/**
 * The booking section on /b2b (components/b2b/sections/BookConsultation.tsx): the founders'
 * booking page, with the "Send us a message" form under it. Every "Book a Consultation" button
 * on the site lands here.
 */
export const BOOK_DEMO_HREF = "/b2b#book-demo";

/**
 * The founders' booking page (Microsoft Bookings or Calendly): shown in that section (framed, or
 * as a "Choose a time" button for links that cannot be framed) and opened by the /b2b hero's
 * button. Set per environment, so changing booking tool or link needs no code change. Null when
 * unset: the section then shows the message form alone.
 */
export const BOOKING_EMBED_URL =
  getEnvVar("VITE_BOOKING_EMBED_URL")?.trim() ||
  getEnvVar("NEXT_PUBLIC_BOOKING_EMBED_URL")?.trim() ||
  null;

/**
 * The navbar's Get started button: a page that sends organizations on to the demo form and
 * individuals to the course catalog.
 */
export const GET_STARTED_HREF = "/get-started";

export const ATOMCAMP_URL = "https://atomcamp.com";
